<template>
    <employees-show-page
            parent
            v-slot:default="_parent"
    >
        <sub-item-show-view
                v-slot:default="{item: transaction}"
        >
            <subcard>
                <v-simple-table>
                    <tbody>
                    <tr>
                        <th>{{ l('pages.transactions.properties.note') }}</th>
                        <td>{{ transaction.note }}</td>
                    </tr>
                    <tr v-if="transaction.type">
                        <th>{{ l('pages.transactions.properties.type') }}</th>
                        <td>{{ l('pages.transactions.values.type.' + transaction.type) }}</td>
                    </tr>
                    <tr>
                        <th>{{ l('pages.transactions.properties.amount') }}</th>
                        <td><amount currency>{{ transaction.amount }}</amount></td>
                    </tr>
                    <tr>
                        <th>{{ l('pages.transactions.properties.created_at') }}</th>
                        <td>{{ transaction.created_at | euroDateShortTime }}</td>
                    </tr>
                    <tr>
                        <th>{{ l('pages.transactions.properties.created_by') }}</th>
                        <td>{{ transaction.created_by | listName }}</td>
                    </tr>
                    <tr v-if="transaction.created_at !== transaction.updated_at">
                        <th>{{ l('pages.transactions.properties.updated_at') }}</th>
                        <td>{{ transaction.updated_at | euroDateShortTime }}</td>
                    </tr>
                    <tr v-if="transaction.created_at !== transaction.updated_at">
                        <th>{{ l('pages.transactions.properties.updated_by') }}</th>
                        <td>{{ transaction.updated_by | listName }}</td>
                    </tr>
                    </tbody>
                </v-simple-table>

            </subcard>
        </sub-item-show-view>
    </employees-show-page>
</template>

<script>
    import EmployeesShowPage from '../../show'
    import Subcard from '../../../../Shared/Cards/Subcard'
    import SubItemShowView from '../../../../Item/Views/SubItemShowView'
    import Amount from "../../../../Shared/Text/Amount";

    export default {
        name: 'EmployeesShowTransactionsShowPage',
        inheritAttrs: false,
        components: {
            Amount,
            EmployeesShowPage,
            Subcard,
            SubItemShowView,
        },
        data: vm => ({
        }),
    }
</script>

<style scoped>

</style>